import { CellContext } from "@tanstack/react-table";
import { Tag } from "../../types/freight/tag.type";
import { TagsGrid } from "../../components/shared/TagsGrid";
import { DASH_PLACEHOLDER } from "../../constants/dashPlaceholder";

export function shipmentTagsColumn<TData>(accessorKey = "shipmentsTags") {
  return {
    accessorKey,
    header: "Shipment Tags",
    enableSorting: false,
    cell: ({ getValue }: CellContext<TData, unknown>) => {
      const tags = getValue() as Tag[] | undefined;
      return tags && tags.length > 0 ? (
        <TagsGrid tags={tags} />
      ) : (
        DASH_PLACEHOLDER
      );
    },
  };
}
